import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import banner from "../../assets/img/social/sitio-mantenimiento.png";
import bannermd from "../../assets/img/social/sitio-mantenimiento-md.png";
import bannersm from "../../assets/img/social/sitio-mantenimiento-sm.png";
import {  
  Col,
  Row
} from "reactstrap";

class ContainerMantenimiento extends Component {
  constructor(props) {
    super(props);
    //console.log(this.props)
  }

  componentDidMount() {
    
  }

  render() {

    
      return (
        <main className="cr-app" style={{ background: "#ffffff" }}>
          <div className="cr-content container-fluid">
            <div className="container-body-spaces">
              <Row className={"d-none d-lg-block d-xl-block"}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <a href="https://www.aig.com.ec" target="_blank">
                    <img src={banner} alt={''} className={"slide-principal-front"} />
                  </a>
                </Col>
              </Row>

              <Row className={"d-none d-md-block d-lg-none"}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <a href="https://www.aig.com.ec" target="_blank">
                    <img src={bannermd} alt={''} className={"slide-principal-front"} />
                  </a>
                </Col>
              </Row>

              <Row className={"d-none d-sm-block d-md-none"}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <a href="https://www.aig.com.ec" target="_blank">
                    <img src={bannersm} alt={''} className={"slide-principal-front"} />
                  </a>
                </Col>
              </Row>
          
              <Row className={"d-block d-sm-none"}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <a href="https://www.aig.com.ec" target="_blank">
                    <img src={bannersm} alt={''} className={"slide-principal-front"} />
                  </a>
                </Col>
              </Row>

            </div>
          </div>
        </main>
      );
    
  
  }
}

ContainerMantenimiento.propTypes = {
  // ramos: PropTypes.array,
  // fetchRamos: PropTypes.func.isRequired
};

ContainerMantenimiento.defaultProps = {
  //ramos: []
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => {
  return {
  
  };
};

export default withRouter(
  connect(
    null,
    null
  )(ContainerMantenimiento)
);
